import React from 'react';
import { FaRegFlag } from 'react-icons/fa';
import { useTheme } from 'styled-components/native';

import { VectorIconProps } from '~/assets/icons.types';

export const FlagIcon = (props: VectorIconProps) => {
  const { colors } = useTheme();
  const { color = colors.text.default, size = 25 } = props;

  return <FaRegFlag color={color} size={size * 1.5} />;
};
